import React from 'react';
import { Card, CardProps, Col, Container, Row } from 'react-bootstrap';
import { formatPrice } from '../../utils/utils';

export type customOutlinedCardData = {
  title: string;
  totalPrice: number;
  availablePrice: number;
  yearlyPrice: number;
};

export type customOutlinedCardProps = CardProps &
  React.PropsWithChildren<{
    cardData: customOutlinedCardData;
  }>;

const OutlinedCard = ({ cardData, ...props }: customOutlinedCardProps) => {
  return (
    <Container className={`${props.className} p-0 custom-outlined-card`}>
      <Card>
        <Card.Title>{cardData.title}</Card.Title>
        <Card.Body>
          <Row className="m-0 pb-7">
            <Col className="p-0">
              <Row className="m-0">
                <h6 className="p-0 m-0">{formatPrice(cardData.totalPrice)}</h6>
              </Row>
              <Row className="m-0">
                <span className="p-0 subtitle">Total</span>
              </Row>
            </Col>
            <Col className="p-0 d-flex flex-column align-items-end">
              <Row className="m-0">
                <h5 className="p-0 m-0">
                  {formatPrice(cardData.availablePrice)}
                </h5>
              </Row>
              <Row className="m-0 subtitle">
                <span className="p-0 subtitle">Available</span>
              </Row>
            </Col>
          </Row>
          <Row className="m-0">
            <Col className="p-0">
              <Row className="m-0">
                <h6 className="p-0 m-0 yearly">
                  {formatPrice(cardData.yearlyPrice)}
                </h6>
              </Row>
              <Row className="m-0 subtitle">
                <span className="p-0 subtitle">YTD Spending</span>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default OutlinedCard;
